export function generateFileHeader(fileName: string, generatedBy: string = "Attio CLI") {
  return `/* eslint-disable */
/* prettier-ignore */
/* @ts-ignore */
// ${fileName}

// ===========================================================
// This file is generated by the ${generatedBy}. Do not edit directly.
// Any changes made to this file will be overwritten.
// ===========================================================
  `;
}
